import React from 'react';
import { useFormikContext } from 'formik';

import CheckBox from '@components/form/CheckBox';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaErrorMessage from './SociollaErrorMessage';

// eslint-disable-next-line react/prop-types
function SociollaCheckbox({ name, label, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <CheckBox
        value={values[name]}
        checked={values[name] ? true : false}
        onChange={async () => {
          const value = !values[name];
          await setFieldValue(name, value);
          if (onChange) {
            onChange(value);
          }
        }}
        {...otherProps}>
        <SociollaText>{label}</SociollaText>
      </CheckBox>
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaCheckbox;
